import React from 'react';
import { FormControl, FormHelperText } from '@material-ui/core';
import { PasslySelect } from '@app/components/Forms';
import { useTypedTranslation } from '@app/hooks';
import { availableAttributes } from '@app/pages/ssoManager/addEditApplication.enums';

interface IProps {
    value: string;
    onChange: (event: any) => void;
}
const options = availableAttributes.map((attribute) => {
    return { value: attribute, label: attribute };
});

export const AttributeAsUsernameComponent: React.SFC<IProps> = (props: IProps) => {
    const { translation } = useTypedTranslation();

    return (
        <>
        <FormControl>
            <PasslySelect
                {...props}
                id={'usernameAttr-input'}
                label={'ATTRIBUTE_SELECTOR_NAME'}
                name={'usernameIssuedAttr'}
                options={options}
            />
            <FormHelperText>{translation('ATTR_SELECTOR_EXTENDED_HELP')}</FormHelperText>
        </FormControl>
        </>
    );
};
